import type { DocMigration } from "../docMigration";

// re-define the same types and type util local to migration
const builtInSettingTypes = ["PLAN_SETTINGS", "SCHEDULE_SETTINGS", "MASTER_PLAN_SETTINGS"];

function isBuiltInSettings(settings: any): boolean {
  return builtInSettingTypes.includes(settings.type);
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_411: DocMigration = {
  maxSchemaVersion: "0.0.411",
  description: "Rename Master Plan, Plan, and Schedule settings to have Built-In prefix them",
  apply(json: any) {
    for (const id in json.settings) {
      const setting = json.settings[id];

      if (!isBuiltInSettings(setting)) {
        continue;
      }

      setting.name = `Built-In ${setting.name}`;
    }

    return json;
  },
};

export default migration_0_0_411;
